/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Issue_S4Inputs */

const en_mk_tut_issue_s4 = /** @type {(inputs: Mk_Tut_Issue_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For bigger work add **staged sub-issues**: stage 1, 2, 3. Finishing one stage can start the next.`)
};

const id_mk_tut_issue_s4 = /** @type {(inputs: Mk_Tut_Issue_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk pekerjaan besar, tambahkan **sub-issue bertahap**: tahap 1, 2, 3. Menyelesaikan satu tahap bisa memicu tahap berikutnya.`)
};

/**
* | output |
* | --- |
* | "For bigger work add **staged sub-issues**: stage 1, 2, 3. Finishing one stage can start the next." |
*
* @param {Mk_Tut_Issue_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_issue_s4 = /** @type {((inputs?: Mk_Tut_Issue_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Issue_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_issue_s4(inputs)
	return en_mk_tut_issue_s4(inputs)
});